import React, { Component } from "react";
import {
    Panel,
    Modal,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Button,
    InputGroup,
    ButtonGroup
} from "react-bootstrap";
import {
    ToastContainer,
    toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";
import Select             from "react-select";
import                         "react-select/dist/react-select.css";
import JoditEditor from "components/generic/JoditEditor";

import {
    IS_UNDEFINED,
    IS_EMPTY_STRING,
    IS_VALID
} from "utils";

import saveTrail            from '../../utils/saveTrail';

const KEYS = {
    "MOBILE_SIGN_UP_BROWSER": "browser",
    "MOBILE_SIGN_UP_URL": "url",
    "MOBILE_SIGN_UP_POLITICALLY_EXPOSED_PERSION": "politicallyExposedPerson",
    "MOBILE_SIGN_UP_MEMBERSHIP_AGREEMENT": "membershipAgreement",
    "MOBILE_SIGN_UP_DATA_PRIVACY_POLICY": "dataPrivacyPolicy"
};

const KEYS_BOOLEAN = {
    "MOBILE_SIGN_UP_ENABLED_IOS": "isEnabledIOS",
    "MOBILE_SIGN_UP_ENABLED_ANDROID": "isEnabledAndroid"
};

class SignUpConfig extends Component {
    constructor (props) {
        super(props);

        this.getConfig = this.getConfig.bind(this);
        this.saveConfig = this.saveConfig.bind(this);
        this.getData = this.getData.bind(this);
        this.saveData = this.saveData.bind(this);
        this.accessible = this.accessible.bind(this);
    }

    getConfig () {
        let {
            actions
        } = this.props;

        actions.setValue({
            isLoadingConfig: true
        });

        let booleanConfigQuery = new Parse.Query("BooleanConfig");

        booleanConfigQuery.equalTo("name", "MOBILE_SIGN_UP");

        booleanConfigQuery.first()
        .then(data => {
            let stateToUpdate = {
                isLoadingConfig: false
            };

            if (IS_VALID(data)) {
                stateToUpdate.isActive = IS_VALID(data.get("value")) ? data.get("value") : true;
                stateToUpdate.switch_parseObject = data;
            } else {
                stateToUpdate.isActive = true;
            }

            actions.setValue(stateToUpdate);
        }) 
        .catch(err => {
            console.log("getConfig error");
            console.log(err);

            actions.setValue({
                isLoadingConfig: false
            });
        })
    }

    saveConfig () {
        let {
            SignUpConfig,
            actions
        } = this.props;
        
        let {
            isActive,
            switch_parseObject
        } = SignUpConfig

        actions.setValue({ isSavingConfig: true });

        new Promise((resolve, reject) => {
            if (IS_VALID(switch_parseObject)) {
              resolve(switch_parseObject);
            } else {
              let query = new Parse.Query("BooleanConfig");
      
              query
              .equalTo("name", "MOBILE_SIGN_UP")
              .descending("createdAt");
              
              query.first()
              .then(resolve)
              .catch(reject);
            }
        })
        .then((switch_parseObject) => {
            if (IS_UNDEFINED(switch_parseObject)) {
                switch_parseObject = new Parse.Object("BooleanConfig");

                switch_parseObject.set("name", "MOBILE_SIGN_UP");
            }

            switch_parseObject
            .set("value", !isActive);

            return switch_parseObject.save();
        })
        .then((switch_parseObject) => {
            let stateToUpdate = {
                isSavingConfig: false,
                isActive: !isActive,
                showModalConfig: false,
                switch_parseObject
            };
        
            actions.setValue(stateToUpdate);

            saveTrail(
                isActive ? "DEACTIVATE" : "ACTIVATE",
                {
                    isActive: !isActive
                }
            );
        })
        .catch((err) => {
            console.log("saveConfig error");
            console.log(err);

            actions.setValue({
                isSaving: false,
                showModalConfig: false
            });
        });
    }

    getData () {
        let {
            actions
        } = this.props;

        actions.setValue({
            isLoading: true
        });

        let stringConfigQuery = new Parse.Query("StringConfig");

        stringConfigQuery.containedIn("name", Object.keys(KEYS));

        let booleanConfigQuery = new Parse.Query("BooleanConfig");

        booleanConfigQuery.containedIn("name", Object.keys(KEYS_BOOLEAN));

        Promise.all([
            stringConfigQuery.find(),
            booleanConfigQuery.find()
        ])
        .then(([ data, data2 ]) => {
            let stateToUpdate = {
                isLoading: false
            };

            for (let item of data) {
                if (
                    KEYS[item.get("name")] &&
                    KEYS[item.get("name")] === "browser"
                ) {
                    let value = null;

                    if (item.get("value")) {
                        value = {
                            label: item.get("value").charAt(0) + item.get("value").slice(1),
                            value: item.get("value")
                        };
                    }

                    stateToUpdate[KEYS[item.get("name")] + "_parseObject"] = item;
                    stateToUpdate[KEYS[item.get("name")]] = value
                }  else if (KEYS[item.get("name")]) {
                    stateToUpdate[KEYS[item.get("name")] + "_parseObject"] = item;
                    stateToUpdate[KEYS[item.get("name")]] = item.get("value");
                }
            }

            for (let item of data2) {
                if (KEYS_BOOLEAN[item.get("name")]) {
                    stateToUpdate[KEYS_BOOLEAN[item.get("name")] + "_parseObject"] = item;
                    stateToUpdate[KEYS_BOOLEAN[item.get("name")]] = item.get("value") || false;
                }
            }

            actions.setValue(stateToUpdate);
        }) 
        .catch(err => {
            console.log("getConfig error");
            console.log(err);

            actions.setValue({
                isLoading: false
            });
        })
    }

    async saveData () {
        let {
            SignUpConfig,
            actions
        } = this.props;

        let {
            browser_parseObject,
            browser,

            url_parseObject,
            url,

            isEnabledIOS_parseObject,
            isEnabledIOS,

            isEnabledAndroid_parseObject,
            isEnabledAndroid,

            politicallyExposedPerson_parseObject,
            politicallyExposedPerson,

            membershipAgreement_parseObject,
            membershipAgreement,

            dataPrivacyPolicy_parseObject,
            dataPrivacyPolicy
        } = SignUpConfig;

        if (
            !IS_VALID(browser)
        ) {
            toast.warn("Browser is required.");
        } else if (
            !IS_VALID(url) ||
            !IS_VALID(url.trim())
        ) {
            toast.warn("URL is required.");
        } else {
            url = url.trim();

            actions.setValue({
                isLoadingAction: true
            });

            try {
                let stringConfigs = await Promise.all([
                    new Promise((resolve) => {
                        if (browser_parseObject) {
                            resolve(browser_parseObject);
                        } else {
                            let stringConfigQuery = new Parse.Query("StringConfig");

                            stringConfigQuery.equalTo("name", "MOBILE_SIGN_UP_BROWSER");

                            resolve(
                                stringConfigQuery.first()
                            );
                        }
                    }),
                    new Promise((resolve) => {
                        if (url_parseObject) {
                            resolve(url_parseObject);
                        } else {
                            let stringConfigQuery = new Parse.Query("StringConfig");

                            stringConfigQuery.equalTo("name", "MOBILE_SIGN_UP_URL");

                            resolve(
                                stringConfigQuery.first()
                            );
                        }
                    }),
                    new Promise((resolve) => {
                        if (politicallyExposedPerson_parseObject) {
                            resolve(politicallyExposedPerson_parseObject);
                        } else {
                            let stringConfigQuery = new Parse.Query("StringConfig");

                            stringConfigQuery.equalTo("name", "MOBILE_SIGN_UP_POLITICALLY_EXPOSED_PERSION");

                            resolve(
                                stringConfigQuery.first()
                            );
                        }
                    }),
                    new Promise((resolve) => {
                        if (membershipAgreement_parseObject) {
                            resolve(membershipAgreement_parseObject);
                        } else {
                            let stringConfigQuery = new Parse.Query("StringConfig");

                            stringConfigQuery.equalTo("name", "MOBILE_SIGN_UP_MEMBERSHIP_AGREEMENT");

                            resolve(
                                stringConfigQuery.first()
                            );
                        }
                    }),
                    new Promise((resolve) => {
                        if (dataPrivacyPolicy_parseObject) {
                            resolve(dataPrivacyPolicy_parseObject);
                        } else {
                            let stringConfigQuery = new Parse.Query("StringConfig");

                            stringConfigQuery.equalTo("name", "MOBILE_SIGN_UP_DATA_PRIVACY_POLICY");

                            resolve(
                                stringConfigQuery.first()
                            );
                        }
                    })
                ]);

                browser_parseObject = stringConfigs[0];
                url_parseObject = stringConfigs[1];
                politicallyExposedPerson_parseObject = stringConfigs[2];
                membershipAgreement_parseObject = stringConfigs[3];
                dataPrivacyPolicy_parseObject = stringConfigs[4];

                if (!browser_parseObject) {
                    browser_parseObject = new Parse.Object(
                        "StringConfig",
                        {
                            name: "MOBILE_SIGN_UP_BROWSER"
                        }
                    );
                }

                if (!url_parseObject) {
                    url_parseObject = new Parse.Object(
                        "StringConfig",
                        {
                            name: "MOBILE_SIGN_UP_URL"
                        }
                    );
                }

                if (!politicallyExposedPerson_parseObject) {
                    politicallyExposedPerson_parseObject = new Parse.Object(
                        "StringConfig",
                        {
                            name: "MOBILE_SIGN_UP_POLITICALLY_EXPOSED_PERSION"
                        }
                    );
                }

                if (!membershipAgreement_parseObject) {
                    membershipAgreement_parseObject = new Parse.Object(
                        "StringConfig",
                        {
                            name: "MOBILE_SIGN_UP_MEMBERSHIP_AGREEMENT"
                        }
                    );
                }

                if (!dataPrivacyPolicy_parseObject) {
                    dataPrivacyPolicy_parseObject = new Parse.Object(
                        "StringConfig",
                        {
                            name: "MOBILE_SIGN_UP_DATA_PRIVACY_POLICY"
                        }
                    );
                }

                if (
                    !IS_VALID(browser_parseObject.get("value")) ||
                    browser_parseObject.get("value") !== browser.value
                ) {
                    browser_parseObject.set("value", browser.value);
                }

                if (
                    !IS_VALID(url_parseObject.get("value")) ||
                    url_parseObject.get("value") !== url
                ) {
                    url_parseObject.set("value", url);
                }

                if (
                    !IS_VALID(politicallyExposedPerson_parseObject.get("value")) ||
                    politicallyExposedPerson_parseObject.get("value") !== politicallyExposedPerson
                ) {
                    politicallyExposedPerson_parseObject.set("value", politicallyExposedPerson);
                }
                
                if (
                    !IS_VALID(membershipAgreement_parseObject.get("value")) ||
                    membershipAgreement_parseObject.get("value") !== membershipAgreement
                ) {
                    membershipAgreement_parseObject.set("value", membershipAgreement);
                }
                
                if (
                    !IS_VALID(dataPrivacyPolicy_parseObject.get("value")) ||
                    dataPrivacyPolicy_parseObject.get("value") !== dataPrivacyPolicy
                ) {
                    dataPrivacyPolicy_parseObject.set("value", dataPrivacyPolicy);
                }

                let booleanConfigs = await Promise.all([
                    new Promise((resolve) => {
                        if (isEnabledIOS_parseObject) {
                            resolve(isEnabledIOS_parseObject);
                        } else {
                            let booleanConfigQuery = new Parse.Query("BooleanConfig");

                            booleanConfigQuery.equalTo("name", "MOBILE_SIGN_UP_ENABLED_IOS");

                            resolve(
                                booleanConfigQuery.first()
                            );
                        }
                    }),
                    new Promise((resolve) => {
                        if (isEnabledAndroid_parseObject) {
                            resolve(isEnabledAndroid_parseObject);
                        } else {
                            let booleanConfigQuery = new Parse.Query("BooleanConfig");

                            booleanConfigQuery.equalTo("name", "MOBILE_SIGN_UP_ENABLED_ANDROID");

                            resolve(
                                booleanConfigQuery.first()
                            );
                        }
                    })
                ]);

                isEnabledIOS_parseObject = booleanConfigs[0];
                isEnabledAndroid_parseObject = booleanConfigs[1];

                if (!isEnabledIOS_parseObject) {
                    isEnabledIOS_parseObject = new Parse.Object(
                        "BooleanConfig",
                        {
                            name: "MOBILE_SIGN_UP_ENABLED_IOS"
                        }
                    );
                }

                if (!isEnabledAndroid_parseObject) {
                    isEnabledAndroid_parseObject = new Parse.Object(
                        "BooleanConfig",
                        {
                            name: "MOBILE_SIGN_UP_ENABLED_ANDROID"
                        }
                    );
                }

                if (
                    isEnabledIOS_parseObject.get("value") !== isEnabledIOS
                ) {
                    isEnabledIOS_parseObject.set("value", isEnabledIOS);
                }

                if (
                    isEnabledAndroid_parseObject.get("value") !== isEnabledAndroid
                ) {
                    isEnabledAndroid_parseObject.set("value", isEnabledAndroid);
                }

                let data = await Parse.Object.saveAll([
                    browser_parseObject,
                    url_parseObject,
                    politicallyExposedPerson_parseObject,
                    membershipAgreement_parseObject,
                    dataPrivacyPolicy_parseObject,
                    isEnabledIOS_parseObject,
                    isEnabledAndroid_parseObject
                ]);

                let stateToUpdate = {
                    isLoadingAction: false,
                    browser_parseObject: data[0],
                    url_parseObject: data[1],
                    politicallyExposedPerson_parseObject: data[2],
                    membershipAgreement_parseObject: data[3],
                    dataPrivacyPolicy_parseObject: data[4],
                    isEnabledIOS_parseObject: data[5],
                    isEnabledAndroid_parseObject: data[6]
                };

                actions.setValue(stateToUpdate)

                toast.success("Data has been updated.");

                saveTrail(
                    "UPDATE",
                    {
                        Browser: browser.value,
                        URL: url.trim(),
                        'Politically Exposed Person': politicallyExposedPerson.trim(),
                        'Membership Agreement': membershipAgreement.trim(),
                        'Privacy Policy': dataPrivacyPolicy.trim(),
                        iOS: isEnabledIOS.toString(),
                        Android: isEnabledAndroid.toString()
                    }
                );
            } catch (error) {
                console.log("saveData error");
                console.log(error);

                actions.setValue({
                    isLoadingAction: false
                });

                this.getData();
            }
        }
    }

    accessible (actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

    render () {
        let {
            SignUpConfig,
            accessjson,
            actions
        } = this.props;

        let {
            isLoadingAction,

            showModalConfig,
            isSavingConfig,
            isLoadingConfig,
            isActive,

            browser,
            browserOptions,
            
            url,

            isEnabledIOS,
            isEnabledAndroid,

            politicallyExposedPerson,

            membershipAgreement,

            dataPrivacyPolicy
        } = SignUpConfig;

        let isActivateAccessible = this.accessible("ACTIVATE") === "",
            isDeactivateAccessible = this.accessible("DEACTIVATE") === "",
            isUpdateAccessible = this.accessible("UPDATE") === "";

        const editorConfig = {
            readonly: false,
            disabled: !isUpdateAccessible || isLoadingAction,
            globalFullSize: false,
            toolbarSticky: false,
            buttons: 'bold,italic,underline,strikethrough,eraser,ul,ol,font,fontsize,paragraph,classSpan,lineHeight,superscript,subscript,file,spellcheck,copyformat,cut,copy'
        };
        
        return (
            <div>
                <Panel>
                    <Panel.Heading style={{
                        backgroundColor: '#D1282F',
                        color: 'white'
                    }}>
                        <h4 style={{ display: "inline-block" }}>Sign Up Config</h4>
                        <div style={{ float: "right" }}>
                            <Button
                                style={(isActive ? !isDeactivateAccessible : !isActivateAccessible) ? { cursor: "not-allowed" } : null}
                                bsStyle={isLoadingConfig ? null : isActive ? "success" : "danger"}
                                disabled={isLoadingConfig || (isActive ? !isDeactivateAccessible : !isActivateAccessible)}
                                onClick={() => {

                                    if (
                                        (isActive ? !isDeactivateAccessible : !isActivateAccessible)
                                    ) {
                                        return;
                                    }

                                    actions.setValue({
                                        showModalConfig: true
                                    });
                                }}
                            >
                                {isLoadingConfig ? (
                                    <i className="fa fa-spinner fa-spin"/>
                                ) : (
                                    isActive ? "ACTIVE" : "INACTIVE"
                                )}
                            </Button>
                        </div>
                    </Panel.Heading>
                    <Panel.Body>
                        <Row>
                            <Col md={6} mdOffset={3}>
                                <FormGroup>
                                    <ControlLabel>
                                        Browser
                                    </ControlLabel>
                                    <Select
                                        disabled={!isUpdateAccessible || isLoadingAction}
                                        clearable={false}
                                        options={browserOptions}
                                        value={browser}
                                        onChange={(value) => {
                                            actions.setValue({
                                                browser: value
                                            });
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} mdOffset={3}>
                                <FormGroup>
                                    <ControlLabel>
                                        URL
                                    </ControlLabel>
                                    <FormControl
                                        disabled={!isUpdateAccessible || isLoadingAction}
                                        value={url}
                                        onChange={(e) => {
                                            actions.setValue({
                                                url: e.target.value
                                            });
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} mdOffset={3}>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <ControlLabel>
                                                iOS
                                            </ControlLabel>
                                            <br/>
                                            <ButtonGroup>
                                                <Button
                                                    bsStyle={isEnabledIOS ? "success" : null}
                                                    disabled={!isUpdateAccessible || isLoadingAction}
                                                    onClick={() => actions.setValue({
                                                        isEnabledIOS: true
                                                    })}
                                                >
                                                    Enable{isEnabledIOS && "d"}
                                                </Button>
                                                <Button
                                                    bsStyle={!isEnabledIOS ? "danger" : null}
                                                    disabled={!isUpdateAccessible || isLoadingAction}
                                                    onClick={() => actions.setValue({
                                                        isEnabledIOS: false
                                                    })}
                                                >
                                                    Disable{!isEnabledIOS && "d"}
                                                </Button>
                                            </ButtonGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <ControlLabel>
                                                Android
                                            </ControlLabel>
                                            <br/>
                                            <ButtonGroup>
                                                <Button
                                                    bsStyle={isEnabledAndroid ? "success" : null}
                                                    disabled={!isUpdateAccessible || isLoadingAction}
                                                    onClick={() => actions.setValue({
                                                        isEnabledAndroid: true
                                                    })}
                                                >
                                                    Enable{isEnabledAndroid && "d"}
                                                </Button>
                                                <Button
                                                    bsStyle={!isEnabledAndroid ? "danger" : null}
                                                    disabled={!isUpdateAccessible || isLoadingAction}
                                                    onClick={() => actions.setValue({
                                                        isEnabledAndroid: false
                                                    })}
                                                >
                                                    Disable{!isEnabledAndroid && "d"}
                                                </Button>
                                            </ButtonGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} mdOffset={3}>
                                <FormGroup>
                                    <ControlLabel>
                                        Politically Exposed Person
                                    </ControlLabel>
                                    <JoditEditor
                                        name="Politically-Exposed-Person"
                                        value={politicallyExposedPerson}
                                        config={editorConfig}
                                        onChange={(politicallyExposedPerson) => {
                                            actions.setValue({
                                                politicallyExposedPerson
                                            });
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} mdOffset={3}>
                                <FormGroup>
                                    <ControlLabel>
                                        Membership Agreement
                                    </ControlLabel>
                                    <JoditEditor
                                        name="membership-agreement"
                                        value={membershipAgreement}
                                        config={editorConfig}
                                        onChange={(membershipAgreement) => {
                                            actions.setValue({
                                                membershipAgreement
                                            });
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} mdOffset={3}>
                                <FormGroup>
                                    <ControlLabel>
                                        Data Privacy Policy
                                    </ControlLabel>
                                    <JoditEditor
                                        name="Data-Privacy-Policy"
                                        value={dataPrivacyPolicy}
                                        config={editorConfig}
                                        onChange={(dataPrivacyPolicy) => {
                                            actions.setValue({
                                                dataPrivacyPolicy
                                            });
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} style={{ textAlign: "center" }}>
                                {isUpdateAccessible &&
                                <Button
                                    bsStyle="primary"
                                    onClick={this.saveData}
                                >
                                    {isLoadingAction && <span><i className="fa fa-spinner fa-spin" style={{color: "white"}}/> </span>}Save
                                </Button>
                                }
                            </Col>
                        </Row>
                    </Panel.Body>
                </Panel>
                <Modal
                    show={showModalConfig}
                    onHide={() => {
                        if (!isSavingConfig) {
                            actions.setValue({
                                showModalConfig: false
                            });
                        }
                    }}
                    bsSize="small"
                >
                    <Modal.Header closeButton>
                        <h4>{isActive ? "DEACTIVATE " : "ACTIVATE "} SIGN UP</h4>
                    </Modal.Header>
                    <Modal.Body>
                        {`Are you sure you want to ${isActive ? "deactivate" : "activate"} Sign Up?`}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            bsStyle={isActive ? "danger" : "success"}
                            disabled={isSavingConfig}
                            onClick={() => this.saveConfig()}
                        >
                            {isActive ? "DEACTIVATE" : "ACTIVATE"}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <ToastContainer/>
            </div>
        );
    }

    componentDidMount () {
        this.getConfig();

        this.getData();
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
    SET_SIGNUP_CONFIG
}                           from "actions/const";

function mapStateToProps(state) {
	var {
		accessjson,
        SignUpConfig
	} = state;
	return {
		accessjson,
        SignUpConfig
	};
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: (keyValueObj, actioType = SET_SIGNUP_CONFIG) => generics.setValue(actioType, keyValueObj)
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpConfig);


// WEBPACK FOOTER //
// ./components/SignUpConfig/index.js